import React from "react";
import { Button } from "@/components/ui/button";
import { CheckCircle2, ArrowRight } from "lucide-react";
import { HID } from "@/constants/cosecIds";

const COL_A = [
  "Track Companies House filing deadlines",
  "Access registers and company records instantly",
  "Submit filings faster with fewer errors",
];
const COL_B = [
  "Maintain accurate shareholder & director records",
  "Keep company data updated in real time",
  "Save hours with automated workflows",
];

export default function RecordsFilings() {
  return (
    <section className="py-20 md:py-28">
      <div className="container-cv grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-6 order-2 lg:order-1">
          <div className="relative">
            <div className="absolute -inset-6 bg-accent/10 rounded-3xl blur-2xl" />
            <img
              src="/assets/cosec-records-filings.png"
              alt="Manage company records and filings digitally, illustrated dashboard with orbiting feature icons"
              className="relative w-full h-auto rounded-2xl"
              loading="lazy"
              data-testid="records-filings-image"
            />
          </div>
        </div>

        <div className="lg:col-span-6 order-1 lg:order-2">
          <span className="section-eyebrow">Records, filings &amp; compliance</span>
          <h2 className="mt-4 font-display text-3xl md:text-5xl font-bold text-primary tracking-tight leading-[1.08]">
            Manage Company Records, Filings &amp; Compliance in{" "}
            <span className="text-accent">One Platform.</span>
          </h2>
          <p className="mt-5 text-base md:text-lg text-muted-foreground leading-relaxed max-w-xl">
            Manual company record-keeping and statutory filings can waste time and
            create compliance risks. CoSec helps UK businesses centralise records,
            automate filings, and stay organised with one secure entity management
            platform.
          </p>
          <p className="mt-3 font-display text-lg md:text-xl font-bold text-primary tracking-tight">
            Simplify company secretarial work with automation and control.
          </p>

          <div className="mt-6 grid sm:grid-cols-2 gap-x-6 gap-y-3">
            {COL_A.concat(COL_B).map((t, i) => (
              <div key={i} className="flex items-start gap-2.5">
                <span className="lime-tick mt-0.5"><CheckCircle2 className="h-4 w-4" /></span>
                <span className="text-sm text-primary/90 font-medium leading-relaxed">{t}</span>
              </div>
            ))}
          </div>

          <Button
            asChild
            data-testid={HID.ctaRecords}
            className="mt-8 h-12 px-6 bg-primary hover:bg-primary/90 text-primary-foreground font-semibold"
          >
            <a href="/contact">
              Book a Demo <ArrowRight className="ml-2 h-4 w-4" />
            </a>
          </Button>
        </div>
      </div>
    </section>
  );
}
